import { Config, IISMethods, LoginInfo } from './config/IISMethods'

//ms config
export const getMsalConfig = async (clientId, tenantId, redirectUri) => ({
    auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/organizations`, // This is the default authority for Microsoft identity platform
        redirectUri: Config.microsoftredirectionurl,
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set to true if you are having issues on IE11 or Edge
    },
})

export const loginRequest = {
    scopes: ["User.Read"],
    prompt: "select_account", // For every time select an account Aniket Bhesaniya 🛠️  ~ 2025-07-31 ~ 015:14 PM
}

const getAccessToken = async () => {

    const url = Config.weburl + 'getaccesstoken'

    const reqData = {
    }

    let headers = {
        key: IISMethods.getCurrentState()['REACT_APP_KEY'],
        issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
        version: Config.version
    }

    //PRIYANSHI --> SOCKET

    //PRIYANSHI --> SOCKET
    let { resBody, resHeaders } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

    if (resBody.status === 200) {
        LoginInfo.setToken(resHeaders.token)
        LoginInfo.setUnqkey(resBody.data.unqkey)
        LoginInfo.setUid(resBody.data.uid)
    }
    else {
        //getAccessToken()
    }
}

export const fetchMsalConfig = async (subdomainname) => {
    try {
        if(!LoginInfo.getToken()){
            await getAccessToken()
        }
        const url = Config.weburl + 'appinit'

        let headers = {
            token: LoginInfo.getToken(),
            unqkey: LoginInfo.getUnqkey(),
            uid: LoginInfo.getUid(),
            key: IISMethods.getCurrentState()['REACT_APP_KEY'],
            issuer: IISMethods.getCurrentState()['REACT_APP_ISSUER'],
            version: Config.version,
            moduletype: 'web',
            subdomainname: subdomainname
        }

        let reqData = {
            os: 1,
            subdomainname: subdomainname
        }

        //PRIYANSHI --> SOCKET 
        let { resBody } = await IISMethods.socketListData(url, reqData, undefined, false, {}, undefined, false, null, headers)

        if (resBody.status === 200) {
            //  | Aniket Bhesaniya  ~ 2025-04-23 ~ 017:36 PM
            let credentialsinfo = {
                mslogin : resBody?.data[0],
                googlelogin : resBody?.googleAuth[0]
            }
            return credentialsinfo
        }
        else {
        }

    } catch (error) {
        console.error(error);
        return null
    }
}